import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Alert } from '@grandvisionhq/common';
import { Text, Heading } from '@grandvisionhq/elements';
import LoadingStoreCard from '../LoadingStoreCard/LoadingStoreCard.js';
import AlternativeStoreItem from './AlternativeStoreItem.js';

const AlternativeStoreSuggestions = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { className , labels , uiState , stores , getTimeslotLabel , onClickPromptCta , onClickNoStoresAvailableCta , onClickStore  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "uiState",
        "stores",
        "getTimeslotLabel",
        "onClickPromptCta",
        "onClickNoStoresAvailableCta",
        "onClickStore"
    ]);
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({
        className: classnames('alternative-store-suggestions', className),
        ref: ref
    }, rest), uiState === 'prompt-for-stores' ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, {
        component: "p"
    }, labels.prompt), /*#__PURE__*/ React.createElement("button", {
        onClick: onClickPromptCta,
        type: "button"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "link",
        className: "alternative-store-suggestions__link"
    }, labels.promptCta))) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Heading, {
        component: "h4",
        variant: "subheading1",
        className: "alternative-store-suggestions__section-title"
    }, labels.title), uiState === 'loading-stores' && /*#__PURE__*/ React.createElement("div", {
        className: "alternative-store-suggestions__cards-container"
    }, Array.from({
        length: 3
    }).map((_, i)=>/*#__PURE__*/ React.createElement(LoadingStoreCard, {
            key: i
        })
    )), uiState === 'stores-available' && /*#__PURE__*/ React.createElement("div", {
        className: "alternative-store-suggestions__cards-container"
    }, stores === null || stores === void 0 ? void 0 : stores.map((item)=>/*#__PURE__*/ React.createElement(AlternativeStoreItem, {
            key: item.store.code,
            item: item,
            getTimeslotLabel: getTimeslotLabel,
            onClickStore: onClickStore
        })
    )), uiState === 'no-stores-available' && /*#__PURE__*/ React.createElement("div", {
        className: "alternative-store-suggestions__no-stores-available"
    }, /*#__PURE__*/ React.createElement(Alert, {
        icon: "info"
    }, /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Text, null, labels.noStoresAvailable, "\xa0"), /*#__PURE__*/ React.createElement("button", {
        onClick: onClickNoStoresAvailableCta,
        type: "button"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "link",
        className: "alternative-store-suggestions__link"
    }, labels.noStoresAvailableCta)))))));
});

export { AlternativeStoreSuggestions as default };
//# sourceMappingURL=AlternativeStoreSuggestions.js.map
